import React, { useState } from "react"

import { ButtonPrimary } from "../../../../../clux-ui/components"
import { LEVELS } from "../../config/constants"
import { DetectiveCluxConfig, Level } from "../../config/interfaces"

import "./style.scss"

interface ReglagesProps {
  title: string
  background: string
  parchment: string
  texts: DetectiveCluxConfig["reglages"]
  onChooseLevel: (level: Level, checkAnswers: boolean) => void
}

const LEVEL_GROUP_LABEL_ID = "dc-reglages-niveaux"
const CHECK_ANSWERS_ID = "dc-reglages-controle"

/** Étape des réglages : texte d'introduction de l'enquête, choix du niveau et du mode contrôle */
const Reglages = ({
  title,
  background,
  parchment,
  texts,
  onChooseLevel,
}: ReglagesProps) => {
  // Coché par défaut : le joueur est guidé à chaque indice
  const [checkAnswers, setCheckAnswers] = useState(true)

  return (
    <div className="dc-reglages">
      <div
        className="dc-reglages__frame"
        style={{ backgroundImage: `url(${background})` }}
      >
        <div className="dc-reglages__content">
          <h1 className="dc-visually-hidden">{title}</h1>
          <div className="dc-reglages__text">{texts.introduction}</div>
          <p
            className="dc-reglages__question"
            style={{ backgroundImage: `url(${parchment})` }}
          >
            {texts.question}
          </p>
          <div className="dc-reglages__text">{texts.conclusion}</div>

          <div
            className="dc-reglages__levels"
            role="group"
            aria-labelledby={LEVEL_GROUP_LABEL_ID}
          >
            <span id={LEVEL_GROUP_LABEL_ID} className="dc-visually-hidden">
              Choisis ton niveau de difficulté
            </span>
            {LEVELS.map(level => (
              <ButtonPrimary
                key={level}
                onClick={() => onChooseLevel(level, checkAnswers)}
              >
                {`Niveau ${level}`}
              </ButtonPrimary>
            ))}
          </div>

          <div className="dc-reglages__option">
            <input
              id={CHECK_ANSWERS_ID}
              type="checkbox"
              className="dc-reglages__checkbox"
              checked={checkAnswers}
              onChange={event => setCheckAnswers(event.target.checked)}
            />
            <label htmlFor={CHECK_ANSWERS_ID}>
              Activer le contrôle de bonne réponse pour chaque indice
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Reglages
